export enum HealthUnitsTypes {
  GETALL = '@healthUnits/GETALL',
  GETALL_SUCCESS = '@healthUnits/GETALL_SUCCESS',
  GETALL_FAILED = '@healthUnits/GETALL_FAILED',
}
